module.exports = __webpack_public_path__ + "img/w3_circle_in_stock_black.6d18df82.png";